/* esm.sh - applesauce-signers@5.2.0/signers/readonly-signer */
export * from "/*applesauce-signers@5.2.0/esnext/signers/readonly-signer.mjs";
